import React from 'react'
import { Popover } from 'antd'
import QRCode from 'qrcode.react'
import { CopyText } from '~/components/business/CopyText'

export const ArticleShare: React.FC<{
  title?: string
  shareUrl: string
  style?: React.CSSProperties
  className?: string
}> = props => {
  const { shareUrl, title, style, className } = props

  return (
    <div style={style} className={className}>
      <CopyText dark={false} text={`《${title}》｜ 无界AI! ${shareUrl}`}>
        <img
          src="/images/article/icon-share-link.svg"
          alt=""
          className="w-7 h-7 mr-4"
        />
      </CopyText>

      <Popover
        overlayClassName={'light'}
        content={
          <QRCode
            value={shareUrl}
            size={100}
            style={{ margin: '-2px -6px' }}
          ></QRCode>
        }
        placement="bottom"
      >
        <img
          src="/images/article/icon-share-wechat.svg"
          alt=""
          className="w-7 h-7"
        />
      </Popover>
    </div>
  )
}
